import { useMutation } from "react-query";
import { sendRequest } from "../sendRequest";

export const reConnectYt = async ({ data, token }) => {
  const response = await sendRequest(
    "post",
    "/influencer/social-media-access/youtube/reauth",
    { ...data },
    {
      Authorization: `Bearer ${token}`,
    }
  );
  return response;
};

export default function useReConnectYt() {
  return useMutation(reConnectYt);
}
